import React from 'react';
import { Link } from 'react-router-dom';
import UnderConstruction from '../portfolio/UnderConstruction';

const addLineBreaks = (string) =>
  string.split('\n').map((text, index) => (
    <React.Fragment key={`${text}-${index}`}>
      {text}
      <br />
    </React.Fragment>
  ));

const Brief = (props) => {
  const {
    year,
    themeColor,
    company,
    role,
    leadParagraph,
    nextPage,
    pageUrl,
    workingProgress
  } = props;

  return (
    <section>
      <div className="grid" style={{
          backgroundColor: themeColor,
          backgroundImage: themeColor,
        }}>
        <div className="container container--floating">
            <div className="wrap">
              <div className="col col-1">
                  <h5 className="summary">{year}</h5>
                  <span className="role">{role}</span>
              </div>

              <div className="col col-1 col-1-2--m">
                  <h2 className="slogan remove-margin-top">{addLineBreaks(company)}                  {workingProgress === true ? <UnderConstruction/> : null }</h2>
              </div>

              <div className="col col-1 col-1-2--m">
                <p className="smaller">{addLineBreaks(leadParagraph)}</p>

                {pageUrl !== null && (
                  <div className="call-to-action">
                    <Link
                      className="link link-convert"
                      to={pageUrl}
                      alt={company}
                    >
                      <span>{nextPage}</span>
                    </Link>
                  </div>
                )}
              </div>
            </div>
        </div>
      </div>
    </section>
  );
};

export default Brief;



// WEBPACK FOOTER //
// ./src/layout/hero/Brief.js